import Cookies from 'js-cookie';

const isShortcutToDesign = () => {
  return Cookies.get('shortcut_to_design') === 'show';
};

export default isShortcutToDesign;
